export const ConstantAlertType = {
    SUCCESS: 'success',
    ERROR: 'error',
    BLANK: '',
}